import { Component, OnInit, ChangeDetectorRef, DoCheck } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';

@Component({
  selector: 'app-manage-users-and-contact',
  templateUrl: './manage-users-and-contact.component.html',
  styleUrls: ['./manage-users-and-contact.component.css']
})
export class ManageUsersAndContactComponent implements OnInit, DoCheck {
  gridData: any[];
  userDetail: any[];
  userRoles: any[];
  isAddUserOpened: boolean;
  isNewUser: boolean;
  userInfo: any;
  allUsersData: any;
  selectedDataItem: any;
  msg = '';
  isDeleteOpened: boolean;
  userContactGrid: boolean;
  operators: any;
  deleteUserMsg: any;
  displayload = false;
  scrollMessage: any;

  constructor(private usersService: UsersService,
    private authService: AuthService,
    private cdRef: ChangeDetectorRef,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    this.userContactGrid = true;
    this.loadUsers();
    this.operators = this.authService.getAccessOperations(2);
    const config = this.readConfigService.getUserManagement();
    this.deleteUserMsg = config.DeleteUserMsg;
    this.scrollMessage = this.readConfigService.getMobileScrollMessage();
  }

  ngDoCheck() {
    this.cdRef.detectChanges();
  }

  loadUsers(): void {
    this.notificationService.setUpLoading(true);
    this.usersService.getUsers().subscribe(users => {
      if (users && users.result && users.result.length > 0) {
        users.result.forEach((ele: any) => {
          let hideOthr = "Other Files";
          if (ele.roles) {
            ele.roles = ele.roles.split(",").filter(x => x.trim() != hideOthr).join('<br />');
          }
          ele.contacts = ele.contacts.split(",").filter(x => x.trim() != hideOthr).join('<br />');
        });
        this.gridData = users.result;
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    }, (error: HttpErrorResponse) => {
      console.log(error);
      this.notificationService.setUpLoading(false);
      this.notificationService.setErrorNotification();
    });
  }

  actionClicked(e: any) {
    if (e === 'yes') {
      this.userContactGrid = true;
    } else {
      this.userContactGrid = false;
    }
  }

  displayResult(e: any) {
    if (e && e.success) {
      setTimeout(() => {
        this.loadUsers();
      }, 100);
    }
    this.notificationService.setUpNotification(e);
  }

  userHandler(e: any) {
    this.userInfo = e;
  }

  openDeleteDialog({ dataItem }: any) {
    this.selectedDataItem = dataItem;
    this.isDeleteOpened = true;
  }

  close(status: any) {
    if (status === 'yes') {
      this.displayload = true;
      this.removeHandler();
    } else {
      this.isDeleteOpened = false;
    }
  }

  removeHandler() {
    this.usersService.deleteUsersData(this.selectedDataItem.id, this.selectedDataItem.emailAddress).subscribe(data => {
      if (data && data.success) {
        this.isDeleteOpened = false;
        this.displayload = false;
        setTimeout(() => {
          this.loadUsers();
        }, 100);
        this.notificationService.setUpNotification(data);
      } else {
        this.isDeleteOpened = false;
        this.displayload = false;
        this.notificationService.setErrorNotification();
        this.notificationService.setUpLoading(false);
      }
    }, (error: HttpErrorResponse) => {
      console.log(error);
      this.displayload = false;
      this.isDeleteOpened = false;
      this.notificationService.setUpLoading(false);
      this.notificationService.setErrorNotification();
    });
  }

}
